// Header translations
const headerTranslations = {
  en: {
    tagline: "independent / creative / technology",
    menu: {
      open: "Open menu",
      close: "Close menu"
    },
    navigation: {
      services: "services",
      lab: "lab",
      gallery: "gallery",
      about: "about",
      contact: "contact"
    }
  },
  de: {
    tagline: "unabhängig / kreativ / technologie",
    menu: {
      open: "menü öffnen",
      close: "menü schließen"
    },
    navigation: {
      services: "dienstleistungen",
      lab: "werkstatt",
      gallery: "galerie",
      about: "über uns",
      contact: "kontakt"
    }
  }
};

export default headerTranslations;